import { serviceTwoFA } from 'services';
import useMutationHookWrapper, {
    TAsyncStatesHandlers,
} from 'hooks/use-mutation-hook-wrapper';
import { twoFA, network } from 'types';

const useConfirm2FAMutation = (
    arg0?: TAsyncStatesHandlers<network.TQueryDefWrapper<null>, string>,
) => {
    return useMutationHookWrapper<
        network.TQueryDefWrapper<null>,
        string,
        twoFA.TConfirmtwoFA
    >({
        mutationFn: serviceTwoFA.confirm,
        mutationConfig: {
            onSuccess: (data) => {},
            onError: (data) => {},
        },
        asyncStateHandlers: arg0,
    });
};

export default useConfirm2FAMutation;
